import React from 'react'
import { Avatar, Tooltip } from '@mui/material'
import { AllInclusive } from '@mui/icons-material'
import { TableColumn } from '../../components/_EOS/GenericTable'
import { StockReserveVsAvailableDto } from '../../components/StockReserve/types'
import { ProductOrigin } from '../../interfaces/Producto/ProductOrigins'
import { Filter } from '../../components/_WMS/FilterComponent'

export const defaultFilter: Filter[] = [
  {
    key: 'StockAlert',
    displayValue: 'Sin Stock',
    label: '',
    value: true
  }
]

export const getImage = (imagen: string) =>
  imagen && imagen.length > 0
    ? imagen
    : 'https://via.placeholder.com/150/e5e5e5/808080?text=Sin%20Imagen'

export const generateTableColumns = (
  productOrigins: ProductOrigin[] | undefined
): TableColumn<StockReserveVsAvailableDto>[] => {
  // Los keys usan el casing real que devuelve el backend (no coincide del
  // todo con StockReserveVsAvailableDto), igual que el GenericTable
  // anterior. Se castea la config completa para no forzar ese tipado.
  return [
    {
      key: 'productImage',
      title: 'Imagen',
      sortable: false,
      render: (value: string) => (
        <Avatar variant='square' alt='SkuImage' src={getImage(value)} />
      )
    },
    { key: 'sku', title: 'SKU', sortable: true },
    { key: 'ean13', title: 'Ean13', sortable: true },
    {
      key: 'productOriginId',
      title: 'Marca',
      sortable: true,
      render: (value: string) =>
        productOrigins?.find(
          (el) => el.productOriginId === parseInt(value)
        )?.name || ''
    },
    { key: 'warehouseName', title: 'Almacén' },
    { key: 'totalQuantity', title: 'Stock Físico' },
    { key: 'reservedQuantity', title: 'Stock Reservado' },
    { key: 'availableQuantity', title: 'Stock Disponible' },
    {
      key: 'SkuId',
      title: 'Stock Venta En Verde',
      render: (_value: unknown, row: StockReserveVsAvailableDto) => {
        if (!row) return 'N/A'

        // Si no es venta verde, mostrar "No"
        if (!row.isGreenSale) {
          return 'NO'
        }

        // Si es cantidad infinita, mostrar icono de infinito
        if (row.isInfiniteQty) {
          return (
            <Tooltip title={`Stock infinito: ${row.virtualStockSale}`}>
              <AllInclusive />
            </Tooltip>
          )
        }

        // En caso contrario, mostrar el valor de virtualStockSale
        return String(row.virtualStockSale)
      }
    }
  ] as unknown as TableColumn<StockReserveVsAvailableDto>[]
}
